export default __webpack_public_path__ + "static/media/glyspace.d2bcf542.png";